module.exports = __webpack_public_path__ + "img/sovit_slide3.24a56351.png";